import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditDocument() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/DocumentLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Document Type"
      alert="Document Edited Successfully"
      editDataAPIEndPoint={`/DocChecklist/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/DocChecklist/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Document Type",
              name: "DC_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "DC_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        DC_Name: {
          required: true,
          
        },
        DC_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditDocument;
